// src/store/auth.module.js
import { apiClient } from "@/services/auth-header";
import AuthService from "@/services/auth.service";
import { useUnreadStore } from "@/store/unread.module";
import { parseUserFromStorage } from "@/utils/userStorage";
import { STORAGE_KEYS } from "@/common/common-enum";
import { useAnalytics, EVENT_TYPES } from "@/composables/useAnalytics";
import { defineStore } from "pinia";

const user = parseUserFromStorage();
const initialState = user
  ? { loggedIn: true, user }
  : { loggedIn: false, user: null };

export const useAuthStore = defineStore("auth", {
  state: () => ({
    status: initialState,
  }),
  actions: {
    async login(reqDto) {
      try {
        const loggedInUser = await AuthService.login(reqDto);
        this.loginSuccess(loggedInUser);
        return Promise.resolve(loggedInUser);
      } catch (error) {
        this.loginFailure();
        return Promise.reject(error);
      }
    },
    snsLogin(user) {
      if (user.accessToken) {
        localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(user));
        this.loginSuccess(user);
      }
    },
    logout() {
      // 스토리지 비우기 전에 발화 — user_type 등 컨텍스트 보존
      useAnalytics().trackEvent(EVENT_TYPES.LOGOUT);
      AuthService.logout();
      this.logoutSuccess();
    },
    loginSuccess(user) {
      this.status.loggedIn = true;
      this.status.user = user;
      const unreadStore = useUnreadStore();
      unreadStore.fetchAllUnreadCounts();
    },
    loginFailure() {
      this.status.loggedIn = false;
      this.status.user = null;
    },
    logoutSuccess() {
      this.status.loggedIn = false;
      this.status.user = null;
    },
    async refreshRoleType() {
      const roleType = this.status.user?.roleType;

      if (!roleType) {
        return;
      }

      try {
        const response = await apiClient.get("/v1/auth/current-role");
        const loginResDto = response.data;

        if (!loginResDto || !loginResDto.roleType) {
          return;
        }

        // JWT 구조: LoginResDto 그대로 저장 (기존 구조 유지)
        localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(loginResDto));
        this.status.user = loginResDto;
      } catch (error) {
        console.error("Error refreshing role type:", error);
      }
    },
  },
  getters: {
    isAuthenticated: (state) => state.status.loggedIn,
  },
});
